import React from 'react';
import http from '../../../axios/http';
import "../../../style/largeScreen/index.css";
import CountUp from 'react-countup';
import ChartMapLine from '../demo/chart/ChartMapLine';

class ChartBarData extends React.Component {
    state = {
        dataInfo:{
            todayAccount:0,
            todayNum:0,
            yearAccount:0,
            yearNum:0,
        }
    }
    // constructor(props) {
    //     super(props);
    // }
    componentWillMount(){
        http.post({
            url: '/applySummary/findTradeSummary',
            success: (res) => {
                this.setState({
                    dataInfo:{
                        todayAccount:res.todayAccount,
                        todayNum:res.todayNum,
                        yearAccount:res.yearAccount,
                        yearNum:res.yearNum,
                    }
                })
            }
        });  
    }
    calculationWidth(data) {
        let tWidth = (data/100) * 800;
        return tWidth;
    }
    render() {
        return (
            <div className='contentBg' style={{ width: "100%", height: "100%" }}>
                {/* <Row>
                    <Col style={{ padding: '10px' }}>
                        <Typography.Title className='todayTitle' >今日交易总额（元）</Typography.Title >
                    </Col>
                </Row> */}
                <div className="acount">
                    <div className='todayAcount'>
                        {/* {account} */}
                        <span className='todayAcount-txt'>今日交易额（元）</span> 
                        <span className="todayAcount-money"><CountUp start={0} separator=","  useGrouping='true' end={this.state.dataInfo.todayAccount} /></span>
                    </div>
                    <div></div>
                    <div className="todayAcount-detail">
                        <div className="todayAcount-content">
                            <div className="todayAcount-title">今日交易量（辆）<span className="todayAcount-num"><CountUp separator="," start={0} end={this.state.dataInfo.todayNum} /></span></div>
                            <div className="todayAcount-num"></div>
                        </div>
                        <div className="todayAcount-content">
                            <div className="todayAcount-title">年交易量（辆）<span className="todayAcount-num"><CountUp separator="," start={0} end={this.state.dataInfo.yearNum} /></span></div>
                            <div className="todayAcount-num">  </div>
                        </div>
                        <div className="todayAcount-content">
                            <div className="todayAcount-title">年交易额(（元）<span className="todayAcount-num"><CountUp separator="," start={0} end={this.state.dataInfo.yearAccount} /></span></div>
                            <div className="todayAcount-num"> </div>
                        </div>
                    </div>
                </div>
                <ChartMapLine />
                {/* <div className="acountTop">
                    <div className='acountTop-title'>《用户区域Top10</div>
                    <table>
                        <thead>
                        <tr>
                            <td>排名</td>
                            <td>区域</td>
                            <td>占出</td>
                            <td></td>
                        </tr>
                        </thead>
                       <tbody>
                       {
                            tableData.map((item, index) => {
                                return <tr>
                                    <td>{item.id}</td>
                                    <td>{item.area}</td>
                                    <td>{item.proportion}%</td>
                                    <td><div className="dataLine" style={{ width:this.calculationWidth(item.proportion) +'px' }} ></div></td>
                                </tr>
                            })
                        }
                       </tbody>
                    </table>
                </div> */}
            </div>
        )
    }

}
export default ChartBarData;